import { useWatch } from "react-hook-form";
import { ConvertedValueHint } from "@/v2/ui/composed/measurement/ConvertedValueHint";
import type { HintSourceUnit } from "@/v2/utils/measurement";

interface FormConvertedValueHintProps {
  name: string;
  from: HintSourceUnit;
}

/** ConvertedValueHint for a react-hook-form field, which owns its own value. */
export function FormConvertedValueHint({
  name,
  from,
}: FormConvertedValueHintProps) {
  const value = useWatch({ name });

  return <ConvertedValueHint value={value} from={from} />;
}
